/**
 * 处理websocket连接信息
 * 1.是否关于头文件的处理也放在这里？ 否
 * 2.是否兼容多条连接？ 问题3告诉我们，在这个文件中开始连接，这使得兼容多条连接具有可能性，结论参见问题6
 * 3.是否还要有开始连接的动作？ 开始连接的动作只在此文件中完成，不再每次使用中
 * 4.问题3带来的项目只要启动就会建立一条websocket连接，不论进入那个页面，是否有问题？否
 * 5.如果只有一个server端，为什么还要有多条链接？ 结论参见问题6
 * 6.这条是关于多条连接的结论，目前只处理一个server中一条连接。原因：建立websocket连接本身耗时，且一条能做完成的事，为什么要分多条。关于多条连接的事情暂不考虑。同一个url但是不同的参数，或者，url带参数如何处理，并不是websocket连接数，关于连接数问题已经在websocket中做了处理。
 * 7.一个onMessage方法
 * 8.需要头文件的config，
 * 9.一个队列处理消息，onMessage只是把头文件和回调关联起来，在消息返回时，找到对应回调处理
 * 10.需要创建一个回调字典和消息队列
 * 11.一个字段name对应一个头文件，对应一个回调。
 * 12.在调用onMessage方法时，回调字典添加一条记录
 * 13.大多数根据op和seq来辨别
 * 14.根据op来收发数据
 * 15.发送数据也要有队列，保证收发的seq，匹配
 * 16.不同操作，不同配置
 * 17.消息队列总存储的都是含有头文件的数据
 */
import Sleep from '../sleep';
const PoolDic = {}; // 循环读取完成收发消息队列的处理

const MESSAGE_HANDLER = {
  startFlag: false,

  install(transfer, config) {
    let pool = {};
    PoolDic[config.name] = pool;
    pool.EMIT_QUEUE = []; // 发消息队列

    pool.RECEIVE_QUEUE = []; // 收消息队列

    pool.transfer = transfer; // websocket实例，运输信息

    pool.onClose = data => MESSAGE_HANDLER[config.name].onClose(data);

    pool.onError = data => MESSAGE_HANDLER[config.name].onError(data);

    pool.onOpen = data => MESSAGE_HANDLER[config.name].onOpen(data); // 给websocket添加事件


    transfer.onMessage = data => pool.RECEIVE_QUEUE.push(data);

    transfer.onClose = pool.onClose;
    transfer.onError = pool.onError;
    transfer.onOpen = pool.onOpen;
    MESSAGE_HANDLER[config.name] = {};

    MESSAGE_HANDLER[config.name].send = data => {
      pool.EMIT_QUEUE.push(data); // console.log('pool.EMIT_QUEUE', JSON.stringify(pool.EMIT_QUEUE))
    }; // 执行关闭


    MESSAGE_HANDLER[config.name].close = transfer.close;
    MESSAGE_HANDLER[config.name].getNum = transfer.getNum;
    MESSAGE_HANDLER[config.name].config = config; // 此处需被重写(以下为监听)

    MESSAGE_HANDLER[config.name].onMessage = data => data && console.log('onMessage', data);

    MESSAGE_HANDLER[config.name].onOpen = data => data;

    MESSAGE_HANDLER[config.name].onError = data => data;

    MESSAGE_HANDLER[config.name].onClose = data => data;

    MESSAGE_HANDLER[config.name].get = () => pool; // 获取当前链接


    if (!MESSAGE_HANDLER.startFlag) {
      MESSAGE_HANDLER.run();
    }
  },

  // 获取全部连接
  getAll: () => PoolDic,
  // 启动调度函数
  run: async () => {
    if (MESSAGE_HANDLER.startFlag) {
      return false;
    }

    MESSAGE_HANDLER.startFlag = true;

    while (true) {
      Object.keys(PoolDic).forEach(async poolName => {
        let pool = PoolDic[poolName];

        if (!pool.transfer) {
          return false;
        }

        if (pool.EMIT_QUEUE.length) {
          pool.transfer && pool.transfer.hasStart && pool.transfer.send(pool.EMIT_QUEUE.shift());
        }

        if (pool.RECEIVE_QUEUE.length) {
          await MESSAGE_HANDLER[poolName].onMessage(pool.RECEIVE_QUEUE.shift());
        }
      });
      await Sleep(8);
    }
  }
};
export default MESSAGE_HANDLER;